import { Clickable, Col, LockGradient, Row, Shoutout, ShoutoutsPage, Text } from 'components';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ShoutoutsRow = ({
  contentLocked,
  handleUnlock,
  data,
  handleLike,
  title,
  marg,
  handleSignup
}) => {
  const [showPage, setShowPage] = useState(false),
    [items, setItems] = useState(data || []),
    { t } = useTranslation(),
    isMobile = useSelector((state) => state.appState.isMobile),
    user = useSelector((state) => state.user),
    observer = useRef();

  // `items` is seeded from the prop but owned locally (deletes remove from it),
  // so it has to resync whenever the parent refetches — otherwise a newly posted
  // shout-out only appears after a manual page refresh
  useEffect(() => {
    setItems(data || []);
  }, [data]);

  function handleDelete(id) {
    setItems((prev) => prev.filter((x) => x._id !== id));
  }

  function handleShowPage() {
    if (!user) return handleSignup();

    setShowPage(true);
  }

  if (!items?.length) return null;

  return (
    <React.Fragment>
      <ShoutoutsPage
        visible={showPage}
        setVisible={setShowPage}
        data={items}
        onDelete={handleDelete}
      />

      <Col wid="100%" marg={marg || '24px 0 0'}>
        <Row
          pad={isMobile && '0 16px'}
          between
          wid={isMobile ? 'calc(100% - 32px)' : '100%'}
          center
        >
          <Text h2>{title}</Text>

          <Clickable onClick={contentLocked ? handleUnlock : handleShowPage}>
            <Text b2 bold>
              {contentLocked ? t('common.unlock') : t('common.seeAll')}
            </Text>
          </Clickable>
        </Row>

        <Row
          start
          ref={observer}
          wid={isMobile ? '100vw' : '100%'}
          scrollX={isMobile}
          marg={isMobile ? '8px 0 0' : '16px 0 0'}
          gap={isMobile ? '16px' : '24px'}
          pos="relative"
        >
          {items.slice(0, 3).map((x, i) => (
            <Row marg={isMobile && i === 0 && '0 0 0 16px'} key={i}>
              <Shoutout item={x} user={x.from} handleClick={handleLike} onDelete={handleDelete} />
            </Row>
          ))}

          <LockGradient visible={contentLocked} observer={observer} />
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default ShoutoutsRow;
